import AppProvider from './context/AppProvider'
import Content from './widgets/content/Content'
import Background from './components/bg/Background'
import Load from './widgets/load/Load'
import './App.css';

function App() {

  return (
    <AppProvider>
      <div className="App">
        <Load />
        <Content />
        <Background />
      </div>
    </AppProvider>
    
  );
}

export default App;
